var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChatinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 102 102",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101 41c0-22.077-22.404-40-50-40S1 18.923 1 41c0 13.046 7.953 25.273 21.309 32.759L16 101l22.045-21.366A61.815 61.815 0 0051 81c27.596 0 50-17.923 50-40z",
    fill: "url(#chat_inline_svg__chat_inline_svg___Linear1)",
    stroke: "#364148",
    strokeWidth: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "chat_inline_svg__chat_inline_svg___Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(123.719 35.828 25.728) scale(107.4292)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0082c3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00639e",
    stopOpacity: 1
  })))));
}

export default SvgChatinline;